<template>
  <el-cascader v-model="val"
               :size='size'
               :style='cssStyle'
               :placeholder="placeholder"
               :options="options"
               :props="props"
               :clearable="clearable"
               :filterable="filterable"
               :disabled="disabled"
               @change="change">
  </el-cascader>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      default: "mini"
    },
    cssStyle: {
      default: "width: 100%"
    },
    placeholder: {
      default: ''
    },
    clearable: {
      default: true
    },
    filterable: {
      default: true
    },
    disabled: {
      default: false
    },
    props: {
      default: function() {
        return {
          value: 'id',
          multiple: false,
          checkStrictly: false,
        }
      }
    },
    options: {},
    value: {},
  },
  data() {
    return {
      val: this.value,
      items: this.options || [],
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    },
    options: function(options) {
      this.items = options;
    },
  },
  methods: {
    change(val) {
      this.$emit('change', val, this.items);
    }
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxCascader.vue